import { $UserAddPermissions, ACTIONS } from "@store/user-store";
import { setTitle } from "@store/title-store";
import { TitleProps } from "@store/title-store";
import { WorkspaceDirectoryShortDataT } from "@interfaces/company/workspace";
import { TableTopPanel } from "@components/common";
import { ColorfulButton } from "@components/common/common";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { $ResponsibilityDocuments } from "@store/responsibility-store";
import { ResponsibilityTable } from "@components/tables";
import clsx from "clsx";

import style from "@scss/pages/responsibility.module.scss";

import useModal from "@modals/modal-hook";
import { useUnit } from "effector-react";

export enum ResponsibilityRequestTypeEnum {
  RESPONSIBILITY = "RESPONSIBILITY",
  LEGAL_INFORMATION = "LEGAL_INFORMATION",
}

const Responsibility = () => {
  const permissions = useUnit($UserAddPermissions);
  const currentDocuments = useUnit($ResponsibilityDocuments);
  const [sortOption, setSortOption] = useState<number>(0);
  const [paths, setPaths] = useState<WorkspaceDirectoryShortDataT[]>([]);

  const { pathname, search } = useLocation();
  const { open } = useModal();

  useEffect(() => {
    const title = [
      { title: "Главная", href: "/" },
      { title: "Дополнительная информация", href: "/additional" },
      { title: "Ответственность", href: pathname },
    ] as TitleProps[];

    const urlParams = new URLSearchParams(search);
    if (urlParams.has("folder_id") && paths.length) {
      paths
        .filter((e) => e !== undefined)
        .forEach((e, i) => {
          const disabled = i < paths.filter((e) => e !== undefined).length - 2;
          title.push({
            title: e.name,
            href: `${pathname}?folder_id=${e.id}`,
            disabled,
          });
        });
    }

    setTitle(title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <>
      {/* TABLE TOP PANEL */}
      <TableTopPanel
        text={`Папок: ${currentDocuments[1].length} Файлов: ${currentDocuments[0].length}`}
        hideSearchPanel
        onSelectOption={(option) => setSortOption(option.value)}
      />
      {/* CREATION BUTTONS */}
      <div className={clsx(style.creation_buttons)}>
        {permissions.hasPermission(
          ACTIONS.responsibility_files_allowedToCreate
        ) && (
          <ColorfulButton
            text={"Загрузить документы"}
            onClick={() =>
              open("UploadResponsibilityModal", {
                modalData: {
                  type: ResponsibilityRequestTypeEnum.RESPONSIBILITY,
                },
              })
            }
          />
        )}
        {permissions.hasPermission(
          ACTIONS.responsibility_directories_allowedToCreate
        ) && (
          <ColorfulButton
            text={"Создать папку"}
            plusIcon={false}
            onClick={() =>
              open("CreateFolderModal", {
                modalData: {
                  modalTitle: "Создать папку",
                  responsibilityMode: true,
                },
                btnText: "Создать",
              })
            }
          />
        )}
      </div>
      {/* TABLE */}
      <ResponsibilityTable setPathsMain={setPaths} sort={sortOption} />
    </>
  );
};

export default Responsibility;
